"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCOPING_PARAMETER_GROUP = exports.CommandLineConstants = void 0;
/**
 * String constants for command line processing.
 *
 * @public
 */
var CommandLineConstants;
(function (CommandLineConstants) {
    /**
     * The name of the built-in action that serves suggestions for tab-completion
     */
    CommandLineConstants["TabCompletionActionName"] = "tab-complete";
})(CommandLineConstants || (exports.CommandLineConstants = CommandLineConstants = {}));
exports.SCOPING_PARAMETER_GROUP = Symbol('scoping');
//# sourceMappingURL=Constants.js.map